
import { RadioGroup } from '@/components/atoms/RadioGroup';
import type { ActivityFormData } from '../ActivityEditorPage.types';
import styles from './TypeSpecificFields.module.scss';

interface TrueFalseFieldsProps {
  correctAnswer: boolean;
  onChange: (updates: Partial<ActivityFormData>) => void;
}

export function TrueFalseFields({ correctAnswer, onChange }: TrueFalseFieldsProps) {
  const handleChange = (value: string) => {
    onChange({ correctAnswer: value === 'true' });
  };

  return (
    <div className={styles.typeFields}>
      <h3 className={styles.typeFields__title}>Verdadero/Falso</h3>
      <p className={styles.typeFields__description}>Selecciona la respuesta correcta para esta afirmación.</p>

      <RadioGroup
        value={correctAnswer ? 'true' : 'false'}
        onValueChange={handleChange}
        options={[
          { value: 'true', label: 'Verdadero' },
          { value: 'false', label: 'Falso' },
        ]}
        label="Respuesta correcta"
        required
      />
    </div>
  );
}
